export const isAccommodationPackage = (pkg: App.Package): pkg is App.AccommodationPackage => {
  return 'fk_room_type_id' in pkg && 'fk_room_rate_id' in pkg;
};

export const isTourPackage = (pkg: App.Package): pkg is App.TourPackage => {
  return 'fk_tour_id' in pkg && 'fk_tour_option_id' in pkg;
};

// Type narrowing functions for offer types
export const isHotelOfferType = (offerType: string): offerType is App.AccommodationOfferType => {
  return ['hotel', 'tactical_ao_hotel', 'last_minute_hotel', 'bundle_and_save', 'rental'].includes(offerType);
};

export const isTourOfferType = (offerType: string): offerType is App.TourOfferType => {
  return ['tour'].includes(offerType);
};
